import type { IProductEntity } from '@/entities';
import { useStorage } from '@vueuse/core';
import { ELocalStorageKeys } from '~/features/store/ELocalStorageKeys';

export class _LastSeenProductsStore {
  public lastSeenProducts = useStorage<IProductEntity[]>(
    ELocalStorageKeys.MM_LAST_SEEN_PRODUCTS,
    [],
    localStorage,
    {
      listenToStorageChanges: false,
      writeDefaults: false,
    }
  );

  public addProduct(product: IProductEntity) {
    if (!product.id) return;

    if (!this.lastSeenProducts.value.find((el) => el.id === product.id)) {
      this.lastSeenProducts.value.splice(0, 0, product);
    }

    if (this.lastSeenProducts.value.length > 10) {
      this.lastSeenProducts.value.pop();
    }
  }
}

export const LastSeenProductsStore = new _LastSeenProductsStore();

// @ts-ignore
window.LastSeenProductsStore = LastSeenProductsStore;
